import type { FieldValues, UseFormReturn } from 'react-hook-form';

import { useLocation, useNavigate } from 'react-router';

import { bypassBlocker } from '~/constants/router';
import { SearchParamKeys } from '~/constants/url';
import { persistFormDataInSession } from '~/utils/form';
import { qs } from '~/utils/searchParams';

/**
 * Navigates away from a create/edit form while persisting the current form state and carrying a
 * redirect back to this page.
 */
export const useNavigateWithRedirect = <T extends FieldValues>(form: UseFormReturn<T>) => {
  const location = useLocation();
  const navigate = useNavigate();

  return (pathname: string, hash?: string) => {
    persistFormDataInSession(window.location.pathname, form.getValues());
    navigate({ hash, pathname, search: qs({ [SearchParamKeys.REDIRECT_PATH]: location.pathname }) }, { state: bypassBlocker });
  };
};
